import React, { Component } from 'react'
import { withRouter } from 'react-router'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import InviteDeclinePageUI from './InviteDeclinePageUI.js'

class InviteDeclinePageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      newUser: true,
      email: null,
      firstName: null,
      lastName: null,
      accountName: null,
      messageList: null,
      errorList: null
    }
  }

  render() {
    return (
      <InviteDeclinePageUI
        context={this.props.context}
        newUser={this.state.newUser}
        email={this.state.email}
        firstName={this.state.firstName}
        lastName={this.state.lastName}
        accountName={this.state.accountName}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.declineInvite(context)
  }

  declineInvite(context) {
    let encryptedUserId = this.props.match.params.encryptedUserId
    let accountId = this.props.match.params.accountId
    RestApiUtils.post(this.props.context,
      `/api/pub/accounts/${accountId}/users/${encryptedUserId}/invite-decline`,
      this.declineInviteCallback, {}
    )
  }

  declineInviteCallback = (response) => {
    if (response.errorList.length) {
      this.setState({
        errorList: response.errorList
      })
    }
    else {
      this.setState({
        newUser: response.newUser,
        email: response.email,
        firstName: response.firstName,
        lastName: response.lastName,
        accountName: response.accountName
      })
    }

    let context = this.props.context
    this.getMessages(context)
  }

  getMessages(context) {
    let arr = [
      'c_invitation_declined',
      'c_acct_inv_dcln_signup',
      'c_acct_inv_dcln_signin',
      'c_acct_inv_dcln_goacc',
      'c_continue',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_inv_dec', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
    // cannot check session here because user id was encrypted in URL
    // this.checkSession()
  }

  /*
  // if user id not matching, logout the user
  checkSession() {
    let context = this.props.context
    let userIdsession = context.session.userId
    let userIdParam = this.props.match.params.userId
    if (userIdsession && userIdsession !== userIdParam) {
      sessions.delete(context, this.deleteSessionCallback)
    }
  }

  deleteSessionCallback = (response) => {
    let context = this.props.context
    localStorage.removeItem(LocalStorageKeys.Session)
    localStorage.removeItem(LocalStorageKeys.Session + ':CachedTime')
    let sessionHelper = new SessionHelper(context)
    sessionHelper.getSession()
  }
  */

}

export default withRouter(InviteDeclinePageSF)
